export const LOAD_EASY_QUERY_XML_INTO_STORE = 'LOAD_EASY_QUERY_XML_INTO_STORE';
export const LOAD_QUERY_LIST_INTO_STORE = 'LOAD_QUERY_LIST_INTO_STORE';
export const LOAD_EASY_QUERY_SEARCH_RESULTS_INTO_STORE = 'LOAD_EASY_QUERY_SEARCH_RESULTS_INTO_STORE';
export const LOAD_EASY_QUERY_ERRORS_INTO_STORE = 'LOAD_EASY_QUERY_ERRORS_INTO_STORE';
export const LOAD_SQL_QUERY_INTO_STORE = "LOAD_SQL_QUERY_INTO_STORE"
